import type { SupportLogServiceName } from './support-logging.types';
import { logger } from './support-logger';

interface GlobalHandlersConfig {
  serviceName: SupportLogServiceName;
  source?: string;
}

export function wireGlobalErrorHandlers(config: GlobalHandlersConfig): void {
  window.onerror = (message, _source, _line, _col, error) => {
    // Skip if already logged by SupportErrorBoundary (React errors bubble here too)
    if (error && (error as Error & { __logged?: boolean }).__logged) return;
    logger?.logError({
      eventName: 'fe.unhandled_error',
      severity: 'error',
      serviceName: config.serviceName,
      source: config.source,
      description: String(message),
      error,
    });
    void logger?.flush();
  };

  window.onunhandledrejection = (event) => {
    logger?.logError({
      eventName: 'fe.unhandled_rejection',
      severity: 'error',
      serviceName: config.serviceName,
      source: config.source,
      description: String(event.reason),
      error: event.reason,
    });
    void logger?.flush();
  };

  // pagehide fires on back/forward navigation (bfcache) as well as tab close
  window.addEventListener('pagehide', () => {
    logger?.flushOnPageHide();
  });
}
